"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnClickOutside = void 0;

require("core-js/modules/es.string.includes.js");

var _react = require("react");

var useOnClickOutside = (ref, handler, enabled) => {
  (0, _react.useEffect)(() => {
    var listener = event => {
      if (enabled && ref.current && !ref.current.contains(event.target) && !event.target.id.includes('burguer-menu')) {
        handler(event);
      }
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};

exports.useOnClickOutside = useOnClickOutside;